/* MATERIAL TAILWIND COMPONENTS */
import { Button, Spinner } from "@material-tailwind/react";

const FormButton = (props) => {
  return (
    <Button
      type={props.type}
      disabled={props.loading}
      onClick={props.onClick}
      className={`h-full py-3.5 px-5 shadow-none rounded-full hover:shadow-none border hover:bg-opacity-80 text-sm font-source font-semibold normal-case flex items-center justify-center leading-none gap-5 transition-all duration-300 ease-in-out ${props.className}`}
    >
      {props.loading ? "Please wait" : props.label}
      {props.loading && <Spinner className="w-4 h-4" />}
    </Button>
  );
};

export { FormButton };
